<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    created() {
    },
    mounted() {
    }
}
</script>

<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/App.vue